var exports = {
  "k": "x7f9a0e16--2f53d8--container",
  "h": "x7f9a0e16--2f53d8--input",
};

module.exports = exports;
